export const topMeels = [
    {
      image: "https://images.pexels.com/photos/604969/pexels-photo-604969.jpeg?auto=compress&cs=tinysrgb&w=600",
      title: "Pizza",
    },
    {
      image: "https://images.pexels.com/photos/1639562/pexels-photo-1639562.jpeg?auto=compress&cs=tinysrgb&w=600",
      title: "Burger",
    },
    {
      image: "https://images.pexels.com/photos/1633525/pexels-photo-1633525.jpeg?auto=compress&cs=tinysrgb&w=600",
      title: "Sandwich",
    },
    {
      image: "https://images.pexels.com/photos/2087748/pexels-photo-2087748.jpeg?auto=compress&cs=tinysrgb&w=600",
      title: "Jollof Rice",
    },
    {
      image: "https://images.pexels.com/photos/3926133/pexels-photo-3926133.jpeg?auto=compress&cs=tinysrgb&w=600",
      title: "Fried Rice",
    },
    {
      image: "https://images.pexels.com/photos/1352274/pexels-photo-1352274.jpeg?auto=compress&cs=tinysrgb&w=600",
      title: "Chicken & Chips",
    },
    {
      image: "https://images.pexels.com/photos/9980749/pexels-photo-9980749.jpeg?auto=compress&cs=tinysrgb&w=600",
      title: "Sharwarma",
    },
    {
      image: "https://images.pexels.com/photos/1275894/pexels-photo-1275894.jpeg?auto=compress&cs=tinysrgb&w=600",
      title: "Ogbona Soup",
    },
    {
      image: "https://images.pexels.com/photos/2365940/pexels-photo-2365940.jpeg?auto=compress&cs=tinysrgb&w=600",
      title: "Afang Soup",
    },
  ];
  